(function () {
    'use strict';
    /**
    * @Factory
    * @name PmtAncillariesProxy
    * @desc Manages the logic of the service get or update ancillaries information
    */
    angular
        .module('ib-pmt-services-http-module')
        .factory('PmtAncillariesProxy', PmtAncillariesProxy);

    PmtAncillariesProxy.$inject = ['$http', '$q', 'localStorageService', 'CommonsCookiesService', 'CommonsLoginConstants'];
    function PmtAncillariesProxy($http, $q, localStorageService, CommonsCookiesService, CommonsLoginConstants) {


        return {
            getAncillaries: getAncillaries,
            getInsurance: getInsurance,
            getConfirmationAncillaries: getConfirmationAncillaries,
            updateAncillaries: updateAncillaries,
            updatePaymentsInfo: updatePaymentsInfo,
            getVoucherValidation: getVoucherValidation,
            deleteVoucher: deleteVoucher
        };

        /**
        * Get all ancillaries of serivice (Baggages, Seats and Insurance)
        * @param {String} uri URI of service
        * @param {String} checkinId Checkin-id of flow
         */
        function getAncillaries(uri, checkinId) {

            return $http.get(uri + checkinId + '/ancillaries').then(getAncillariesComplete)['catch'](getAncillariesFailed);

            function getAncillariesComplete(response) {
                return response.data;
            }

            function getAncillariesFailed(response) {
                return $q.reject({ data: response.data, errorCode: response.status });
            }
        }



        /**
         * Update ancillaries
         * @param {String} uri URI of service
         * @param {String} checkinId Checkin-id of flow
         * @param {Object} data Data of ancillaries for update in service
         */
        function updateAncillaries(uri, checkinId, data) {

            return $http.put(uri + checkinId + '/ancillaries', angular.toJson(data)).then(updateAncillariesComplete)['catch'](updateAncillariesFailed);

            function updateAncillariesComplete(response) {
                return response.data;
            }

            function updateAncillariesFailed(response) {
                return $q.reject({ data: response.data, errorCode: response.status });
            }
        }


        /**
         * Return insurance ancillaries for country
         * @param {String} uri URI of service
         * @param {String} checkinId Checkin-id of flow
         * @param {String} country Country selected for get ancillaries
         */
        function getInsurance(uri, checkinId, country) {

            return $http.get(uri + checkinId + '/ancillaries' + '?ancillaryType=INSURANCE&residenceCountry=' + country).then(getInsuranceComplete)['catch'](getInsuranceFailed);

            function getInsuranceComplete(response) {
                return response.data;
            }

            function getInsuranceFailed(response) {
                return $q.reject({ data: response.data, errorCode: response.status });
            }
        }


        /**
         * Return vehicle rental ancillaries for country
         * @param {String} uri URI of service
         * @param {String} checkinId Checkin-id of flow
         * @param {String} country Country selected for get ancillaries
         */
        function getConfirmationAncillaries(uri, checkinId) {

            return $http.get(uri + checkinId + '/ancillaries' + '?ancillaryType=BOB&ancillaryType=VEHICLE_RENTAL&ancillaryType=CO2_FOOTPRINT').then(getConfirmationAncillariesComplete)['catch'](getConfirmationAncillariesFail);

            function getConfirmationAncillariesComplete(response) {
                return response.data;
            }

            function getConfirmationAncillariesFail(response) {
                return $q.reject({ data: response.data, errorCode: response.status });
            }
        }

        function updatePaymentsInfo(uri, checkinId, data, isRecall) {
            const SF_Headers = {
                headers: {
                    'X-Salesforce-Token': localStorageService.get('loginSF') || CommonsCookiesService.getCookie(CommonsLoginConstants.SSO_COOKIES.SF_LOGGED_TOKEN)
                }
            };
            return isRecall === '3ds2Adyen' || isRecall === 'iberiaPayAfop' ? $http.put(uri + checkinId + '/ancillaries/pay-and-issue/payment-details', angular.toJson(data), localStorageService.get('userLogged') === true ? SF_Headers : null).then(updatePaymentsComplete)['catch'](updatePaymentsFailed) :
                $http.post(uri + checkinId + '/ancillaries/pay-and-issue', angular.toJson(data), localStorageService.get('userLogged') === true ? SF_Headers : null).then(updatePaymentsComplete)['catch'](updatePaymentsFailed);

            function updatePaymentsComplete(response) {
                return response.data;
            }

            function updatePaymentsFailed(response) {
                return $q.reject({ data: response.data, errorCode: response.status });
            }
        }


        /**
         * 
         * @param {*} uri 
         * @param {*} flowId 
         * @param {*} voucherId 
         */
        function getVoucherValidation(uri, flowId, voucherId, data) {
            return $http.post(uri + flowId + '/voucher/validation/' + voucherId, angular.toJson(data)).then(getVoucherValidationComplete)['catch'](getVoucherValidationFail);

            function getVoucherValidationComplete(response) {
                return response.data;
            }

            function getVoucherValidationFail(response) {
                return $q.reject({ data: response.data, errorCode: response.status });
            }
        }


        /**
         * 
         * @param {*} uri 
         * @param {*} flowId 
         * @param {*} voucherId 
         */
        function deleteVoucher(uri, flowId, voucherId) {
            return $http.delete(uri + flowId + '/voucher/remove/' + voucherId).then(deleteVoucherComplete)['catch'](deleteVoucherFail);

            function deleteVoucherComplete(response) {
                return response.data;
            }

            function deleteVoucherFail(response) {
                return $q.reject({ data: response.data, errorCode: response.status });
            }
        }
    }
})();
